export default __webpack_public_path__ + "foursquare-button.png";